import * as CurrencyConverter from './CurrencyConverter.css';

export default {
	CurrencyConverter
};
